var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col align-center progress-board",class:{
    'progress-board-hoverable':_vm.hoverable
  },style:({
    alignItems:_vm.align
  })},[_c('div',{staticClass:"l-name",style:(`${_vm.labelStyle}`)},[_vm._v(_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"l-value",style:(`${_vm.valueStyle};margin:7px 0;`)},[_c('Progress',{staticStyle:{"width":"120px","font-size":"14px"},attrs:{"percent":_vm.value<0?0:_vm.value,"status":"active"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }